<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item active">Главная</li>
		</ol>
	</nav>
	<div class="container-fluid my-2">
		<div v-html="appModel.contentMainpage" v-if="appModel.contentMainpage"></div>
		<div v-else>Добро пожаловать!</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup() {
		useMeta({title: 'Главная | SKV'});
	},
};
</script>
